var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayout11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H1C0.448 9 0 8.552 0 8V1C0 0.448 0.448 0 1 0H6C6.552 0 7 0.448 7 1V8C7 8.552 6.552 9 6 9Z",
    fill: "#B5B7C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H1C0.448 16 0 15.552 0 15V12C0 11.448 0.448 11 1 11H6C6.552 11 7 11.448 7 12V15C7 15.552 6.552 16 6 16Z",
    fill: "#B5B7C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H10C9.448 6 9 5.552 9 5V1C9 0.448 9.448 0 10 0H15C15.552 0 16 0.448 16 1V5C16 5.552 15.552 6 15 6Z",
    fill: "#B5B7C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16H10C9.448 16 9 15.552 9 15V9C9 8.448 9.448 8 10 8H15C15.552 8 16 8.448 16 9V15C16 15.552 15.552 16 15 16Z",
    fill: "#B5B7C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout11);
export default __webpack_public_path__ + "static/media/layout-11.2ad180bbe8212b294dfb9ca910299365.svg";
export { ForwardRef as ReactComponent };